
/**
 * Test points and formatting for wedging tests
 */

export const getTestPointsForWedging = (testId: string): string[] => {
  // Check the current path to determine the level
  const pathname = window.location.pathname;
  const isLevel2 = pathname.includes('level2');
  
  // Level 2 wedging tests
  if (isLevel2) {
    if (testId === "wedging-cercles") {
      return ["D", "E", "F"];
    }
    if (testId === "wedging-mid") {
      return ["D1", "E1", "F1"];
    }
    if (testId === "wedging-pente-gauche") {
      return ["D2", "E2", "F2"];
    }
    return [];
  }
  
  // Level 3 wedging tests (default)
  if (testId === "wedging-cercles") {
    return ["WedgingA", "WedgingB", "WedgingC"];
  }
  if (testId === "wedging-mid") {
    return ["WedgingD", "WedgingE", "WedgingF"];
  }
  if (testId === "wedging-pente-gauche") {
    return ["WedgingA1", "WedgingB1", "WedgingC1"];
  }
  if (testId === "wedging-pente-droite") {
    return ["WedgingA2", "WedgingB2", "WedgingC2"];
  }
  if (testId === "wedging-mid-pente-gauche") {
    return ["WedgingD1", "WedgingE1", "WedgingF1"];
  }
  if (testId === "wedging-mid-pente-droite") {
    return ["WedgingD2", "WedgingE2", "WedgingF2"];
  }
  
  return [];
};

export const getFormattedPointForWedging = (point: string): string => {
  // Level 2 wedging points
  if (point === 'D') return "45m";
  if (point === 'E') return "55m";
  if (point === 'F') return "65m";
  if (point === 'D1') return "75m";
  if (point === 'E1') return "85m";
  if (point === 'F1') return "95m";
  if (point === 'D2') return "45m (pente gauche droite)";
  if (point === 'E2') return "55m (pente gauche droite)";
  if (point === 'F2') return "65m (pente gauche droite)";
  
  // Level 3 wedging points
  if (point === "WedgingA") return "30m";
  if (point === "WedgingB") return "40m";
  if (point === "WedgingC") return "50m";
  if (point === "WedgingD") return "60m";
  if (point === "WedgingE") return "70m";
  if (point === "WedgingF") return "90m";
  
  // Level 3 wedging pente points
  if (point === "WedgingA1") return "30m (pente gauche droite)";
  if (point === "WedgingB1") return "40m (pente gauche droite)";
  if (point === "WedgingC1") return "50m (pente gauche droite)";
  if (point === "WedgingA2") return "30m (pente droite gauche)";
  if (point === "WedgingB2") return "40m (pente droite gauche)";
  if (point === "WedgingC2") return "50m (pente droite gauche)";
  if (point === "WedgingD1") return "60m (pente gauche droite)";
  if (point === "WedgingE1") return "70m (pente gauche droite)";
  if (point === "WedgingF1") return "90m (pente gauche droite)";
  if (point === "WedgingD2") return "60m (pente droite gauche)";
  if (point === "WedgingE2") return "70m (pente droite gauche)";
  if (point === "WedgingF2") return "90m (pente droite gauche)";
  
  return point;
};
